import { Component, OnInit } from '@angular/core';
import { PracticeService } from 'src/app/services/practice.service';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';

@Component({
  selector: 'app-bacsrenewals',
  templateUrl: './bacsrenewals.component.html',
  styleUrls: ['./bacsrenewals.component.scss']
})
export class BacsrenewalsComponent implements OnInit {
  private perPage=20;
  public paginatedPractices = new BehaviorSubject<any>(null);
  public loadingPractices: boolean = true;
  public availableFilters=[];
  private filterString='';

  constructor(
    private _practices: PracticeService
  ) {
    this.availableFilters.push(new FilterOption({name:'name',type:'string',label:'Name'}));
    this.availableFilters.push(new FilterOption({
      name:'owner.subscriptions.plan_id',
      type:'select',
      label: 'Sub Type',
      'options':[
        {name:'Annual',value:1},
        {name:'Monthly',value:2},
        {name:'Any', value:''}
      ],
      default: 'Any'
    }));
    this.availableFilters.push(new FilterOption({
      name:'is_bacs_enabled',
      type:'select',
      label: 'Billing',
      'options':[
        {name:'Invoice',value:1},
        {name:'Online',value:0},
        {name:'Any', value:''}
      ],
      default: 'Any'
    }));
    this.availableFilters.push(new FilterOption({
      name:'disabled',
      type:'select',
      label: 'Status',
      'options':[
        {name:'Active',value:0},
        {name:'Inactive / Disabled',value:1},
        {name:'Any', value:''}
      ],
      default: 'Any'
    }));
  }

  ngOnInit() {
    this.getPractices(1);
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getPractices(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getPractices(1);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getPractices(1);
  }

  public getPractices(page){
    this._practices.getPaginatedBacsRenewals(page,this.perPage,this.filterString).subscribe(paginatedData=>{
      this.paginatedPractices.next(paginatedData);
      this.loadingPractices = false;
    })
  }

}
